import { useContext } from "react";
import { ConfigContext } from "@/contexts/ConfigProvider";
import type { Component } from "@/types/FormConfig";

export function useFormComponentConfig<T extends Component = Component>(
  componentName: string,
): T | null {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error(
      "useFormComponentConfig must be used within a ConfigProvider",
    );
  }

  const component = context.components.find(
    (component) => component.name === componentName,
  );

  if (!component) {
    return null;
  }

  return component as T;
}
